import ThemeLocalization from "./locales/ThemeLocalization";
import DocLayout from "./DocLayout/index";

import ThemeProvider from "./theme";
import { ThemeSettings } from "./components/settings";
import { MSnackbarProvider } from "./components/snackbar";
import { MotionLazyContainer } from "./components/animate";
import { ChooseCodeLanguageProvider } from "./components/ChooseCodeLanguage/ChooseCodeLanguage";

import intercom from "@/utils/support";
import { useEffect } from "react";
import { PhotoProvider } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

function App() {
  useEffect(() => {
    // 初始化客服
    if (!(window as any)?.Intercom) {
      intercom({
        email: "",
        name: "",
        user_id: "",
        user_hash: "",
        showSupport: true,
        background_color: "#c6d7ff",
        action_color: "#3c6ff5",
      });
    }
    // 锚点滚动处理
  }, []);

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <ThemeLocalization>
            <MSnackbarProvider>
              <ChooseCodeLanguageProvider>
                <PhotoProvider>
                  <DocLayout />
                </PhotoProvider>
              </ChooseCodeLanguageProvider>
            </MSnackbarProvider>
          </ThemeLocalization>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}

export default App;
